function camelToKebab(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function arrayify(obj) {
    return obj instanceof Array
        ? obj
        : [obj];
}
function nullify(value) {
    return (value && value.length)
        ? value
        : null;
}
export { camelToKebab, nullify, arrayify };
